var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPublisherGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4941 33.0578C21.4941 27.5643 25.9427 23.1157 31.4362 23.1157C36.9297 23.1157 41.3783 27.5643 41.3783 33.0578C41.3783 33.6101 40.9305 34.0578 40.3783 34.0578C39.826 34.0578 39.3783 33.6101 39.3783 33.0578C39.3783 28.6689 35.8251 25.1157 31.4362 25.1157C27.0473 25.1157 23.4941 28.6689 23.4941 33.0578C23.4941 37.4467 27.0473 40.9998 31.4362 40.9998C33.7516 40.9998 35.8391 40.0063 37.2908 38.4254C37.6643 38.0186 38.2969 37.9917 38.7037 38.3652C39.1105 38.7388 39.1374 39.3714 38.7639 39.7782C36.95 41.7536 34.3356 42.9998 31.4362 42.9998C25.9427 42.9998 21.4941 38.5513 21.4941 33.0578Z",
    fill: "#EE2C63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 28C32.0523 28 32.5 28.4477 32.5 29V37C32.5 37.5523 32.0523 38 31.5 38C30.9477 38 30.5 37.5523 30.5 37V29C30.5 28.4477 30.9477 28 31.5 28Z",
    fill: "#EE2C63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5 33C26.5 32.4477 26.9477 32 27.5 32H35.5C36.0523 32 36.5 32.4477 36.5 33C36.5 33.5523 36.0523 34 35.5 34H27.5C26.9477 34 26.5 33.5523 26.5 33Z",
    fill: "#EE2C63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7415 18.2427C21.2268 18.2427 24.8629 14.6067 24.8629 10.1214C24.8629 5.63606 21.2268 2 16.7415 2C12.2562 2 8.62012 5.63606 8.62012 10.1214C8.62012 14.6067 12.2562 18.2427 16.7415 18.2427Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7814 35.8446C21.268 35.9044 17.5618 35.8446 17.5618 35.8446C8 35.836 5.5 35.4998 2.01155 34.0322C1.66959 25.4492 8.97028 18.4819 17.5618 18.4819C20.8617 18.4819 23.7939 19.5163 26.1961 21.2859C27.2989 22.0981 28.889 23.5941 30.0431 25.5091",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPublisherGroup);
export default __webpack_public_path__ + "static/media/add-publisher-group.1d6375de2f2e48bc1c60008e8644b2ce.svg";
export { ForwardRef as ReactComponent };